var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('load',{attrs:{"message":"Carregando Midia"}}):_c('div',{staticClass:"row"},[_vm._v("\nAdd")])
}
var staticRenderFns = []

export { render, staticRenderFns }